var cibTerraform = ["32 32", "<path d='M11.041 5.688l9.912 5.031v10.073l-9.912-5.037zM22.041 10.719v10.073l9.917-5.037v-10.067zM0.047 0.068v10.068l9.912 5.036v-10.068zM11.041 26.921l9.912 5.037v-10.063l-9.912-5.036z'/>"];

export { cibTerraform };
//# sourceMappingURL=cib-terraform.js.map
